<h2 mat-dialog-title>Delete Unit</h2>
<mat-dialog-content class="mat-typography">
    <h3>Are you sure you want to delete this unit?</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true">Yes</button>
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial>No</button>
</mat-dialog-actions>
